"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPreferencesOperations = void 0;
exports.UserPreferencesOperations = {
    REPLACE: 'REPLACE',
    INCREMENT: 'INCREMENT',
    DELETE: 'DELETE'
};
//# sourceMappingURL=UserPreferencesOperations.js.map